import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, Form, change } from 'redux-form';
import Button from 'material-ui/Button';
import IconButton from 'material-ui/IconButton';
import { MenuItem } from 'material-ui/Menu';
import { CircularProgress } from 'material-ui/Progress';
import Paper from 'material-ui/Paper';
import { Link, Prompt } from 'react-router-dom';

import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card, { CardContent } from 'material-ui/Card';
import { emphasize } from '@material-ui/core/styles/colorManipulator';

import Typography from 'material-ui/Typography';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Close from 'material-ui-icons/Cancel';
import addEditCustomer from '../../../../actions/addEditCustomer';
import addEditLocation from '../../../../actions/addEditLocation';
import RenderDialog from '../../../../helpers/RenderDialog';
import renderCheckBoxGroup from '../../../../helpers/RenderCheckBoxGroup';
import managePortfolios from '../../../../actions/VXC/managePortfolios';
import getPortfolios from '../../../../actions/VXC/getPortfolios';
import search from '../../../../actions/search';
import renderTextField from '../../../../helpers/RenderTextFiledWithDiv';
import renderSelectField from '../../../../helpers/RenderSelectField';
import validationHelper from '../../../../helpers/ValidationHelper';
import normalizePhone from '../../../../helpers/NormalizePhone';

import RenderConfirmationTimeoutDialog from '../../../../helpers/RenderConfirmationTimeoutDialog';

import Layout from '../../../Layout';

const styles = theme => ({
    card: {
        display: 'flex',
        boxShadow: 'none',
    },
    content: {
        flex: '1 0 auto',
    },
    paperStyle: {
        width: '100%',
        height: '70%',
        maxWidth: '1075px',
        display: 'inline-block',
        margin: 20,
        marginTop: '5vh'
    },
    buttonStyle: {
        marginTop: 10,
        marginBottom: 15
    },
    marginStyle: {
        margin: 8
    },
    textField: {
        width: 350
    },
    textFieldportFolio: {
        width: '250px'
    },
    textFieldTest: {
        width: 350,
        marginTop: 0
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    radioGroup: {
        margin: '0 !important',
        textAlign: 'left',
    },
    radioGroupMask: {
        width: '300px',
        paddingTop: '20px'
    },
    radioGroupTest: {
        width: '650px',
        marginTop: '8px'
    },
    headerStyle: {
        position: 'relative',
        width: '100%',
        height: '60px',
        background: '#FFFFFF',
        boxShadow: 'none'
    },
    headerTitleStyle: {
        margin: '2%',
        fontSize: '24px',
        fontFamily: 'Roboto',
        display: 'flex',
        justifyContent: 'space-between'
    },
    addIcon: {
        position: 'absolute',
        margin: '1%'
    },
    root: {
        flexGrow: 1,
        height: 250,
    },
    input: {
        display: 'flex',
        padding: 0,
    },
    valueContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        flex: 1,
        alignItems: 'center',
    },
    reportingLabel: {
        color: '#ADADAD',
        textAlign: 'left',
        marginLeft: '-70%',
        fontSize: '9pt'
    },
    chip: {
        margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
    },
    chipFocused: {
        backgroundColor: emphasize(
            theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
            0.08,
        ),
    },
    noOptionsMessage: {
        padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    },
    singleValue: {
        fontSize: 14,
    },
    placeholder: {
        position: 'absolute',
        left: 2,
        fontSize: 14,
    },
    paper: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
    },
    divider: {
        height: theme.spacing.unit * 2,
    },
    testClass: {
        display: 'block',
        width: '100%'
    },
    wrapperForGrid: {
        maxWidth: '100%',
        width: '100%'
    },
    testingCSSGridOthers: {
        display: 'grid',
        gridTemplateColumns: '33% 33% 33% !important',
        width: '100%',
        padding: '10px 0 0',
        margin: '0 0 20px 0'
    }
});

const validate = (values) => {
    const errors = validationHelper.validateRequired(['customer', 'contactName', 'addressLine1', 'billingAddress', 'address', 'phoneNumber', 'emailAddress', 'autotecPrefix', 'autotecId', 'availableReports'], values);
    if (values.emailAddress && !validationHelper.validateEmail(values.emailAddress)) {
        errors.emailAddress = 'Invalid email address';
    }
    if (values.phoneNumber && !validationHelper.validatePhone(values.phoneNumber)) {
        errors.phoneNumber = 'Invalid phone number';
    }
    const lengthValidation = [
        { field: 'customer', label: 'Customer', value: values.customer, min: 1, max: 50 },
        { field: 'contactName', label: 'Contact Name', value: values.contactName, min: 1, max: 50 },
        { field: 'phoneNumber', label: 'Phone Number', value: values.phoneNumber, min: 1, max: 12 },
        { field: 'emailAddress', label: 'Email Address', value: values.emailAddress, min: 1, max: 65 },
        { field: 'experianId', label: 'Primary Location Experian ID', value: values.experianId, min: 1, max: 50 },
        { field: 'address', label: 'Address', value: values.address, min: 1, max: 50 },
        { field: 'autotecPrefix', label: 'AutoTec Prefix', value: values.autotecPrefix, min: 1, max: 4 },
        { field: 'autotecId', label: 'AutoTec ID', value: values.autotecId, min: 1, max: 8 },
    ];
    validationHelper.validateLength(errors, lengthValidation);
    if (values.autotecId && !validationHelper.validateAutotecID(values.autotecId)) {
        errors.autotecId = '4 alphabetic characters + 4 numeric characters';
    }
    return errors;
};

const removeHyphens = (value) => {
    return value.replace(new RegExp('-', 'g'), '');
};

class AddEditPortfolioForOthers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            openAddress: false,
            fetching: false,
            addressList: {},
            addressType: '',
            hideOwnership: 'none',
            message: null,
            openDialog: false,
            addressPopulated: false,
            buttonColor: '#002053',
            autotecId: '',
            locationId: '',
            redirect: false,
            multi: null,
            custReports: [],
            rulesList: [],
            portfolioDataOthers: [],
            allPortfolioData: [],
            showEdit: false,
            portfolioId: '',
            saving: false,
            setRuleChecks: false,
            portfolioReports: [
                { value: 'temptag', label: 'DMV Temp Tag', editGroup: false, fieldValue: '' },
                { value: 'active_port', label: 'Active Portfolio', editGroup: true, fieldValue: '' },
                { value: 'auct_unsold', label: 'Auction Unsold', editGroup: false, fieldValue: '' },
                { value: 'auct_early', label: 'Auction Sold Early', editGroup: false, fieldValue: '' },
                { value: 'sa_sold', label: 'SA Sold', editGroup: false, fieldValue: '' },
                { value: 'auct_sold', label: 'Auction Sold', editGroup: false, fieldValue: '' },
                { value: 'at_auction', label: 'At Auction', editGroup: false, fieldValue: '' }
            ]
        };
    }

    componentDidMount() {
        this.setDefaultValues();
        if (this.props.match.params.id) {
            this.props.actions.getPortfolioData(this.props.match.params.id, this.props.data.config, this);
        }

        this.props.actions.getAllPortfolioInfo(this.props.match.params.id, this.props.data.config, this);
    }

    setDefaultValues = () => {
        if (!this.props.match.params.id) {
            this.state.portfolioReports.map((report) => {
                this.props.dispatch(change('AddEditPortfolioInfo', report.value, 'Yes'));
                this.props.dispatch(change('AddEditPortfolioInfo', `${report.value}_SD`, 10));
                this.props.dispatch(change('AddEditPortfolioInfo', `${report.value}_DT`, 0));
            })
            this.setDefaultChecks();
        } else {
            this.props.actions.getRules(this.props.match.params.id, this.props.data.config, this);
        }

        this.setState({ addressList: this.props.data.addressList.addressList });
        this.setState({ portfolioData: this.props.data.portfolioFormData.portfolioFormData });

        this.setState({ showEdit: true });
    }

    setInitialChecks = (portfolioData) => {
        let otherCustomerReports = portfolioData.otherCustomerRules;
        otherCustomerReports && this.state.portfolioReports.map((report) => {
            let checked = otherCustomerReports.some(e => e.ruleId == report.value) ? 'Yes' : 'No';
            report.fieldValue = checked;
        });
        !otherCustomerReports && this.setDefaultChecks();
        this.setState( {setRuleChecks: true });
    }

    setDefaultChecks = () => {
        this.state.portfolioReports.map((report) => {
            report.fieldValue = "Yes";
        });
    }


    buildCustomerRulesForSubmission = (event) => {
        const rules = [];
        let institutionData;
        let customerInfo;
        if (this.props.data.customerData.customerData !== undefined) {
            customerInfo = this.props.data.customerData.customerData;
        } else {
            customerInfo = event.customerId;
        }

        if (this.props.data.addressList.addressList) {
            institutionData = this.props.data.institutionData.institutionData;
        }

        Object.keys(event).forEach((key) => {
            let rule;
            if (key === 'rules') {
                event[key].forEach((ruleData) => {
                    rule = ruleData;
                    if (ruleData.ruleId === 'active_port' && institutionData !== undefined) {
                        rule.institutions = institutionData
                    }
                    rules.push(rule);
                })
            }
        });

        const portfolioData = {
            maskName: event.maskName,
            portfolioId: event.portfolioId,
            autotecId: event.portfolioId,
            name: event.name,
            directory: event.directory,
            customerId: event.customerId,
            portfolioType: event.portfolioType,
            postedFileSubmittals: event.postedFileSubmittals,
            alertOtherCustomers: event.alertOtherCustomers,
            rules
        }

        return portfolioData;
    }

    buildOtherCustomerRulesForSubmission = (event) => {
        const otherCustomerRules = [];

        Object.keys(event).forEach((key) => {
            if (event[key] === 'Yes') {
                
                const rule = {
                    delayDate: event[`${key}_DT`],
                    ruleId: key,
                    suppressionDate: event[`${key}_SD`]
                };
                //only add rules if they have defined delayDate and suppressionDates
                if (rule.delayDate && rule.suppressionDate) {
                    otherCustomerRules.push(rule);
                }
            }
        });

        return otherCustomerRules;
    }

    buildLocation = (addressInfo) => {

        const location = {
            addressLine1: addressInfo.addressLine1,
            city: addressInfo.city,
            country: addressInfo.country,
            county: addressInfo.county,
            postalCode: addressInfo.postalCode,
            state: addressInfo.state,
        }

        if (addressInfo.addressLine2) {
            location.addressLine2 = addressInfo.addressLine2;
        }

        return location;
    };

    buildCustomer = (event) => {


        const contactTemplate = {
            contactName: event.contactName,
            emailAddress: event.emailAddress,
            phoneNumber: removeHyphens(event.phoneNumber)
        }

        const customer = {
            name: event.customer,
            customerGroupId: event.customerGroup,
            contact: contactTemplate,
            submissionTypes: event.submissionTypes,
            product: ['vxc'],

        };

        const addressInfo = this.props.data.addressList.addressList;

        if (addressInfo['Billing Address'].addressLine1) {
            customer.billingAddress = this.buildLocation(addressInfo['Billing Address']);
        }
        // else {
        //     customer.billingAddress = this.buildLocation(addressInfo['Physical Address']);
        // }

        const newLocation = this.newPhysicalLocation(addressInfo, contactTemplate, customer);

        return [customer, newLocation];
    };


    handleSave = (event) => {
        const { params } = this.props.match;
        const otherRules = this.buildOtherCustomerRulesForSubmission(event);
        this.setState({ saving: true })
        if (!params.id) {

            let customerData;
            let newLocation;

            const portfolioData = this.buildCustomerRulesForSubmission(this.props.data.portfolioFormData.portfolioFormData)
            if (this.props.data.customerData.customerData) {
                const customerInformation = this.buildCustomer(this.props.data.customerData.customerData);
                [customerData, newLocation] = customerInformation;
                this.props.actions.saveCustomer(customerData, newLocation, portfolioData, this.props.data.config, this);
            }
            portfolioData.otherCustomerRules = otherRules;

            if (!this.props.data.customerData.customerData) {
                this.props.actions.savePortfolio(portfolioData, this.props.data.config, this);
            }
        }

        if (params && params.id) {
            const portfolioData = {
                portfolioId: this.state.portfolioId,
                customerId: this.props.match.params.id,
                otherCustomerRules: otherRules
            }

            this.props.actions.managePortfolios(portfolioData, this.props.data.config, this);
        }

        // localStorage.removeItem('allRows');
        // localStorage.removeItem('customerData');
        // localStorage.removeItem('institutionData');
    };

    handleClear = () => {
        this.props.history.push('/customers');
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleAutotecIdChange = (event) => {
        this.props.dispatch(change('AddEditPortfolioInfo', 'autotecPrefix', event.target.value.substr(0, 4)));
    };


    handleAddressClose = () => {
        this.setState({
            openAddress: false,
            anchorEl: null
        });
    };

    handleEditGroupOpen = (event) => {
        this.setState({
            openEditGroup: true,
            anchorEl: event.currentTarget
        })
    }

    handleEditGroupClose = () => {
        this.setState({ openEditGroup: false })
    }

    checkAddress = (address) => {
        if (Object.keys(address).length > 0) {
            this.setState({ addressPopulated: true });
        } else {
            this.setState({ addressPopulated: false });
        }
    }
    
    handleCheckChange = (event) => {
        const rulesFields = ['active_port', 'auct_early', 'auct_sold', 'sa_sold', 'temptag', 'auct_unsold', 'at_auction'];
        const targetName = event.target.name;
        const targetValue = event.target.value;

        if (targetValue === 'Yes') {
            if (rulesFields.includes(targetName)) {
                this.props.dispatch(change('AddEditPortfolioInfo', event.target.name, 'Yes'));
                this.props.dispatch(change('AddEditPortfolioInfo', `${targetName}_DT`, '0'));
                this.props.dispatch(change('AddEditPortfolioInfo', `${targetName}_SD`, this.setDefaultSubmissionDate(targetName)));
                this.setState((prevState, props) => {
                    const newReports = prevState.portfolioReports;
                    const index = newReports.findIndex(item => item.value === targetName);
                    newReports[index].fieldValue = targetValue;
                    return { portfolioReports: newReports };
                });
            } else {
                this.props.dispatch(change('AddEditPortfolioInfo', `${targetName}`, targetValue));
                this.setState({ [targetName]: targetValue });
            }
        } else {
            if (rulesFields.includes(targetName)) {
                this.props.dispatch(change('AddEditPortfolioInfo', `${targetName}_DT`, ''));
                this.props.dispatch(change('AddEditPortfolioInfo', `${targetName}_SD`, ''));
                this.setState((prevState, props) => {
                    const newReports = prevState.portfolioReports;
                    const index = newReports.findIndex(item => item.value === targetName);
                    newReports[index].fieldValue = targetValue;

                    return { portfolioReports: newReports };
                });
            } else {
                this.props.dispatch(change('AddEditPortfolioInfo', `${targetName}`, targetValue));
                this.setState({ [targetName]: targetValue });
            }

        }
    }

    handleClose = () => {
        this.props.history.push('/customers')
    }

    handleAgree  = () => {
        let customerId = '';
        if (this.props.data.addEditCustomer.newCustomer) {
            customerId = this.props.data.addEditCustomer.newCustomer.data.customerId;
        } else {
            customerId = this.props.data.portfolioFormData.portfolioFormData.customerId;
        }
        
        this.props.history.push(`/add-portfolio/${customerId}`)
    };

    setDefaultSubmissionDate = (evt) => {
        if (['active_port', 'sa_sold'].includes(evt)) {
            return '10'
        }
        return '2'
    }

    handlePortfolioChange = (event) => {
        const rulesFields = ['active_port', 'auct_early', 'auct_sold', 'sa_sold', 'temptag', 'auct_unsold', 'at_auction'];

        const name = event ? event.target.value : this.state.portfolioDataOthers && this.state.portfolioDataOthers.length !== 0 ? this.state.portfolioDataOthers[0].name : "";
        const result = this.state.portfolioDataOthers.filter(portfolio => portfolio.name === name);
        this.setState({ portfolioId: result[0].portfolioId });

        if (event && event.target.value) {
            this.setInitialChecks(result[0]);
        }

        rulesFields.forEach((field) => {
            this.props.dispatch(change('AddEditPortfolioInfo', field, 'No'))
            this.props.dispatch(change('AddEditPortfolioInfo', `${field}_DT`, ''))
            this.props.dispatch(change('AddEditPortfolioInfo', `${field}_SD`, ''))

        })
        !this.state.setRuleChecks && this.setInitialChecks(result[0]);
        let otherRules = result[0]['otherCustomerRules'];
        otherRules && otherRules.map((res) => {
            Object.keys(res).forEach((key) => {
                if (rulesFields.includes(res[key])) {
                    this.props.dispatch(change('AddEditPortfolioInfo', res[key], 'Yes'))
                    this.props.dispatch(change('AddEditPortfolioInfo', `${res[key]}_DT`, res.delayDate));
                    this.props.dispatch(change('AddEditPortfolioInfo', `${res[key]}_SD`, res.suppressionDate));
                }

            })
        })
    }

    saveAlert = () => {
        let dialog = <div />;
        if (this.state.openDialog) {
            dialog =
            (<RenderConfirmationTimeoutDialog
                open={this.state.openDialog}
                stayInAction={() => { this.handleClose(); }}
                handleIdleTimeout={() => { this.handleAgree(); }}
                timeoutInterval={this.props.data.config.ConfirmationTimeout}
                page={this.props.match.params.id ? 'Edit Portfolio' : 'Add Portfolio'}
            />);
        } else {
            dialog = (<div />);
        }
        return dialog;
    }

    changeButtonColor = () => {
        this.setState({ buttonColor: '#002053' });
    }

    handleConfirmSaved = () => {
        if (!this.props.data.addEditCustomer.saved && !this.props.data.addEditLocation.saved) {
            return true;
        }
        return false;
    }

    newPhysicalLocation(addressInfo, contactTemplate, customer) {
        let customerData = {}
        if (addressInfo['Physical Address'].addressLine1) {
            customerData = {
                address: this.buildLocation(addressInfo['Physical Address']),
                autotecId: this.props.data.portfolioFormData.portfolioFormData.autotecId,
                contact: contactTemplate,
                customerId: customer.customerId,
            };
        }

        return customerData;
    }

    render() {
        const dialog = this.saveAlert();
        let portfolioItems = [];
        if (this.props.match.params.id && this.state.portfolioData && this.state.portfolioData.length > 0) {
            portfolioItems = (
                this.state.portfolioData.map((portfolio) => {
                    return (<MenuItem value={portfolio.name}>{portfolio.name}</MenuItem>)
                })
            )
        }
        const optionsList = [{ id: 1, label: 'Yes' }, { id: 2, label: 'No' }];

        const { classes, handleSubmit } = this.props;

        const renderReportOptions = this.state.portfolioReports.map((report) => {
            return (
                <Fragment key={report.value}>

                    <div className="firstItem gridItem">
                        <Field
                            name={report.value}
                            component={renderCheckBoxGroup}
                            options={optionsList}
                            className={classes.radioGroupMask}
                            label={report.label}
                            checked={report.fieldValue}
                            handleCheckChange={this.handleCheckChange}
                        />
                    </div>
                    <div className="secondItem gridItem">
                        <Field
                            name={`${report.value}_SD`}
                            component={renderTextField}
                            label="Suppression Days"
                            className={classes.textFieldportFolio}
                            divClassName={classes.marginStyle}
                        />
                    </div>
                    <div className="thirdItem gridItem">
                        <Field
                            name={`${report.value}_DT`}
                            component={renderTextField}
                            label="Delay Time"
                            className={classes.textFieldportFolio}
                            divClassName={classes.marginStyle}
                        />
                    </div>
                </Fragment>
            )
        })

        if (!this.props.match.params.id) {
            this.props.dispatch(change('AddEditPortfolioInfo', 'vhrOwnership', 'No'));
        }

        const selectStyles = {
            input: base => ({
                ...base,
            }),
        };

        let button = <div align="center"><CircularProgress size={75} /></div>;

        // if (!this.state.fetching) {
        button = (<Button
            variant="raised"
            disabled={this.state.saving}
            style={this.state.saving ? { background: '#ddd' } : { background: '#002053' }}
            type="submit">{this.state.saving ? 'Please wait...' : 'Save'}</Button>);
        // }

        return (
            <Layout
                className="App"
                showMenu
                menuTitle=""
                toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727."
            >
                <Paper className={classes.paperStyle}>
                    {dialog}
                    {/* <Prompt
                        when={this.handleConfirmSaved}
                        message='Any changes will be lost if you leave this screen. Would you like to continue?'
                    /> */}
                    <AppBar position="static" className={classes.headerStyle}>
                        <Toolbar className={classes.headerTitleStyle}>
                            <Typography variant="title" className="lightH2">
                                <span className="pageHeader" style={{ fontSize: '24px' }}>{(this.props.match.params.id) ? 'Edit' : 'Add'} Portfolio Settings for the Reports of Others</span>
                            </Typography>
                            <IconButton title="close" component={Link} to="/customers">
                                <Close color="disabled" />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <Form className="gridFrom" key="AddEditPortfolioInfo" onSubmit={handleSubmit((event) => { this.handleSave(event); })}>
                    {
                        this.state.fetching ?
                        <div align="center"><CircularProgress size={75} /></div>
                        :
                        <Card className={"formCards"}>
                            {/* <CardContent className={classes.content}> */}
                            <div className="wrapperForGrid gridContainer">
                                {this.props.match.params.id &&
                                    <div className="preItem">
                                        <Field
                                            name="portfolioType"
                                            component={renderSelectField}
                                            label="Portfolio Name"
                                            className={classes.textFieldTest}
                                            divClassName={classes.formControl}
                                            children={portfolioItems}
                                            onChange={this.handlePortfolioChange}
                                        />
                                    </div>
                                }
                                {/* <div style={{ minWidth: '1000px', display: 'inline-block' }}> */}
                                <div className="testingCSSGridOthers dataGrid">

                                    {renderReportOptions}
                                </div>
                                {/* </CardContent> 
                            </div> */}
                            </div>
                        </Card>
                    }
                        <div className={classes.buttonStyle}>
                            {button}
                        </div>
                    </Form>
                </Paper>
            </Layout >
        );
    }
}

AddEditPortfolioForOthers.propTypes = {
    classes: PropTypes.shape().isRequired,
    theme: PropTypes.object.isRequired,
};

const initialValues = (customers, reportTypes, ownProps) => {
    const customer = (customers.customers) ?
        customers.customers.customers.filter(item => item.customerId === ownProps.match.params.id)[0] :
        {};

    let values = {};
    if (customer && customer.name && reportTypes.reportTypes) {
        values = {
            customer: customer.name,
            customerGroup: customer.customerGroupId,
            contactName: customer.contact.contactName,
            phoneNumber: normalizePhone(customer.contact.phoneNumber),
            emailAddress: customer.contact.emailAddress,
            invoiceMin: customer.invoiceMinAmount,
            invoiceMax: customer.invoiceMaxAmount,
            autotecPrefix: customer.autotecId.substr(0, 4),
            autotecId: customer.autotecId,
            experianId: customer.experianId
        };

        const reports = [];
        customer.authorizedMethodIds.forEach((methodId) => {
            const report = reportTypes.reportTypes.reportTypes.filter(reportType => reportType.methodId === methodId);
            if (report) {
                reports.push(report[0]);
            }
        });

        // defaults all reports to 'No'
        reportTypes.reportTypes.reportTypes.forEach((report) => {
            values[report.reportTypeId] = 'No';
        });

        // changes reports to Yes if customer has report
        reports.forEach((report) => {
            if (report && report.reportTypeId) {
                values[report.reportTypeId] = 'Yes';
            }
        });
    } else {
        if (reportTypes && reportTypes.reportTypes) {
            reportTypes.reportTypes.reportTypes.forEach((report) => {
                values[report.reportTypeId] = 'No';
            });
        }
    }
    return values;
};

const mapStateToProps = (state, ownProps) => ({
    data: {
        addEditCustomer: state.addEditCustomer,
        addEditLocation: state.addEditLocation,
        portfolioFormData: state.portfolioFormData,
        customerData: state.customerData,
        customers: state.customers,
        customerGroups: state.customerGroups,
        reportTypes: state.reportTypes,
        locations: state.search.locations,
        config: state.config.config,
        error: state.error,
        addressList: state.addressList,
        institutionData: state.institutionData
    },
    initialValues: initialValues(
        state.customers,
        state.reportTypes,
        ownProps
    )
});

const mapDispatchToProps = dispatch => ({
    actions: {
        managePortfolios: (portfolioData, config, self) => {
            dispatch(managePortfolios(portfolioData, config)).then((o) => {
                if (o.action.type === 'ADD_EDIT_PORTFOLIOS_SAVE_FULFILLED') {
                    self.setState({ saving: false, openDialog: true, message: 'Record saved' });
                }
            }).catch(() => {
                self.setState({ buttonColor: '#002053' })
            });
        },
        getPortfolioData: (customerId, config, self) => {
            self.setState({ fetching: true });
            dispatch(getPortfolios(customerId, config)).then((portfolioData) => {
                if (portfolioData.action.type === 'PORTFOLIOS_FETCH_FULFILLED') {
                    self.setState({ fetching: false });
                    if (portfolioData.action.payload.data.Items.length > 0) {
                        self.setState({ portfolioDataOthers: portfolioData.action.payload.data.Items, newRecord: false, showEdit: true }, () => {
                            self.props.dispatch(change('AddEditPortfolioInfo', 'portfolioType', portfolioData.action.payload.data.Items[0].name));
                            self.handlePortfolioChange();
                        });
                    } else {
                        self.setState({ newRecord: true })
                    }
                }
            })
        },
        getAllPortfolioInfo: (customerId, config, self) => {
            dispatch(search('portfolios', 0, null, config)).then((portfolioData) => {
                if (portfolioData.action.payload.data.items.length > 0) {
                    const portData = portfolioData.action.payload.data.items.filter(x => x.customerId !== customerId)
                    self.setState({ allPortfolioData: portData });
                }
            })
        },
        getRules: (customerId, config, self) => {
            dispatch(getPortfolios(customerId, config)).then((portfolioData) => {
                if (portfolioData.action.type === 'PORTFOLIOS_FETCH_FULFILLED') {
                    self.setState({ portfolioData: portfolioData.action.payload.data.Items });
                }
            })
        },
        saveCustomer: (customer, newLocation, portfolioData, config, self) => {
            const newCustomer = customer;
            self.setState({
                saving: true,
                buttonColor: '#ddd'
            });
            if (Object.entries(newLocation).length > 0 && newLocation.constructor === Object) {
                dispatch(addEditLocation(newLocation, config)).then((l) => {
                    const { locationId } = l.value.data;
                    const newLocationVar = newLocation;
                    if (l.action.type === 'ADD_EDIT_LOCATION_SAVE_FULFILLED') {
                        newCustomer.primaryLocationId = locationId;
                        newLocationVar.locationId = locationId;
                        dispatch(addEditCustomer(newCustomer, config)).then((p) => {
                            const customerIdVal = p.action.payload.data.customerId;
                            newLocationVar.customerId = customerIdVal;
                            dispatch(addEditLocation(newLocationVar, config));

                            const newPortfolioData = portfolioData;
                            newPortfolioData.customerId = customerIdVal;
                            self.setState({ saving: true, buttonColor: '#ddd' });
                            dispatch(managePortfolios(newPortfolioData, config)).then((o) => {
                                if (o.action.type === 'ADD_EDIT_PORTFOLIOS_SAVE_FULFILLED') {
                                    self.setState({ saving: false, openDialog: true, message: 'Message saved. Do you wish to enter another one?' });
                                }
                            }).catch(() => {
                                self.setState({ buttonColor: '#002053' })
                            });
                        })
                    }
                }).catch(() => {
                    self.setState({ buttonColor: '#002053' })
                })
            } else {
                dispatch(addEditCustomer(newCustomer, config)).then((p) => {
                    const customerIdVal = p.action.payload.data.customerId;

                    const newPortfolioData = portfolioData;
                    newPortfolioData.customerId = customerIdVal;
                    self.setState({ saving: true, buttonColor: '#ddd' });
                    dispatch(managePortfolios(newPortfolioData, config)).then((o) => {
                        if (o.action.type === 'ADD_EDIT_PORTFOLIOS_SAVE_FULFILLED') {
                            self.setState({ saving: false, openDialog: true, message: 'Message saved. Do you wish to enter another one?' });
                        }
                    }).catch(() => {
                        self.setState({ buttonColor: '#002053' })
                    });
                })
            }
        },
        savePortfolio: (portfolioData, config, self) => {
            const newPortfolioData = portfolioData;
            self.setState({ buttonColor: '#ddd' });
            dispatch(managePortfolios(newPortfolioData, config)).then((o) => {
                if (o.action.type === 'ADD_EDIT_PORTFOLIOS_SAVE_FULFILLED') {
                    self.setState({ saving: false, fetching: false, openDialog: true, message: 'Message saved. Do you wish to enter another one?' });
                }
            }).catch(() => {
                self.setState({ buttonColor: '#002053' })
            });
        }

    }
});

const ReduxForm = withStyles(styles, { withTheme: true })(reduxForm({
    form: 'AddEditPortfolioInfo',
    enableReinitialize: true,
    validate
})(AddEditPortfolioForOthers));

const ConnectedAddEditCustomer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ReduxForm);

export default ConnectedAddEditCustomer;


// WEBPACK FOOTER //
// ./src/components/Customer/Customer/VXC/AddEditPortfolioForOthers.js